import { render, staticRenderFns } from "./table-new.vue?vue&type=template&id=2bdb8607&scoped=true"
import script from "./table-new.vue?vue&type=script&lang=js"
export * from "./table-new.vue?vue&type=script&lang=js"
import style0 from "./table-new.vue?vue&type=style&index=0&id=2bdb8607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb8607",
  null
  
)

export default component.exports